module.exports = __webpack_public_path__ + "img/限时商品2.291d5b5f.png";